<template>
    <div class="main-container">
        <!-- 页面标题 -->
        <div class="page-header">
            <h1 class="page-title">人员考核</h1>
        </div>
        <div class="content">
            <div>
      <a-form-model layout="inline" @keyup.enter.native="query" style="margin-bottom: 2vh">
        <a-row>
          <a-col :span="22">
            <a-form-model-item>
                <RangePickerField labelWidth="0" v-model="form.time" :placeholder="['起始年月', '结束年月']" :disabled="false"/>
            </a-form-model-item>

            <a-form-model-item>
                <SelectField labelWidth="0" :options="typeList" v-model="form.status" id="type" placeholder="考核状态"/>
            </a-form-model-item>

            <a-form-model-item>
              <a-space>
                  <ButtonField text="查询" @click="query" secondary />
                  <ButtonField text="重置" primary @click="reset"/>
              </a-space>
            </a-form-model-item>
          </a-col>

          <a-col :span="2">
            <div class="right" style="margin-top: 4px">
                <ButtonField text="新增" @click="$router.push(`${$route.path}/add`)" secondary />
            </div>
          </a-col>
        </a-row>
      </a-form-model>
        
      <Tablelist
              style="margin-top: 1rem"
              :showCheckbox="false"
              :list="list"
              :columns="tableColumns"
              :totalSize="totalSize"
              :totalPages="totalPages"
              :pageNum="pageNum"
              :pageSize="pageSize"
              @page-change="onChange"
      >
          <template v-slot:actions="{ item }">
              <a-space>
                  <a @click="$router.push({path:`${$route.path}/edit`,query: item})">编辑</a>
                  <a @click="$router.push({path:`${$route.path}/assess`,query: item})">评价</a>
                  <a class="danger" @click.prevent="deleteText(item)">删除</a>
              </a-space>
          </template>
      </Tablelist>

    </div>
        </div>
    </div>
</template>
<script>
import { fetchList, del } from "@/api/personnel-assess";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      form: {},
      list: [],
      loading: false,
      total: 0,
      totalSize: 0,
      totalPages: 0,
      pageNum: 1,
      pageSize: 10,
        tableColumns: [
          {
              key: 'name',
              title: '计划名称',
              field: 'name',
              infotype: 'text'
          },
          {
              key: 'timeBegin',
              title: '考核起始时间',
              field: 'timeBegin',
              infotype: 'text',
          },
          {
              key: 'timeEnd',
              title: '考核终止时间',
              field: 'timeEnd',
              infotype: 'text',
          },
          {
              key: 'assessNum',
              title: '考核人数',
              field: 'assessNum',
              infotype: 'text',
          },
          {
              key: 'status',
              title: '考核状态',
              field: 'status',
              infotype: 'dictType',
              dictType:'assessPlanStatus'
          },
          {
              key: 'actions',
              title: '操作',
              infotype: 'template',
          }
      ],
    };
  },
  mounted() {
    this.getList();
  },
  computed: {
    ...mapGetters("setting", ["findDataDict"]),
    typeList() {
      return this.findDataDict("taskStatus");
    },
  },
  methods: {
    getList() {
      this.loading = true;
      let {  form } = this;
      let { name, status } = form;

      let timeBegin, timeEnd;
      if (Array.isArray(form.time) && form.time.length === 2) {
        timeBegin = form.time[0].format("YYYY-MM-DD");
        timeEnd = form.time[1].format("YYYY-MM-DD");
      }
      fetchList({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        status,
        name,
        timeBegin,
        timeEnd,
      })
        .then((res) => {
          this.loading = false;
          if (Array.isArray(res.list)) {
              this.list = res.list;
              this.totalSize = res.totalSize;
              this.totalPages = res.totalPages;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onChange(pagination) {
      this.pageNum  = pagination;
      this.pageSize = 10;
      this.getList();
    },
    reset() {
      this.form = {};
      this.pageNum  = 1;
      this.pageSize = 10;
      this.getList();
    },
    query() {
      this.pageNum  = 1;
      this.pageSize = 10;
      this.getList();
    },

    deleteText(text) {
      const that = this;
      this.$confirm({
        title: "确认要删除这条考核计划吗？",
        onOk() {
          del({
            id: text.id,
          }).then(() => {
            that.getList();
          });
        },
      });
    },
  },
};
</script>
<style scoped>
.main-container {
    padding:2rem 0;
    width: 80%;
    margin: auto;
}
.page-header {
    margin-bottom: 2rem;
}

.page-title {
    font-size: 2rem;
    margin-bottom: 0.5rem;
    background: linear-gradient(135deg, #fff, #00ff96);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
.content{
    background: rgba(20, 35, 70, 0.5);
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(0, 255, 150, 0.2);
    border-radius: 16px;
    padding: 2rem;
    margin-bottom: 1.5rem;
}
</style>